import React, { useState, useEffect } from "react";
import axios from "axios";
import API_BASE_URL from "../../ApiConfig/ApiConfig";
import { jwtDecode } from "jwt-decode";
import Cookies from "js-cookie";
import { useNavigate } from 'react-router-dom';
const AgreementForm = () => {
  const [hasSubmitted, setHasSubmitted] = useState(false);
  const [formData, setFormData] = useState({
    location: "",
    bankAccountNumber: "",
    ifscCode: "",
    purchaseDistributor: "",
    authorizedDistributor: "",
    partnerName: "",
    contactPersonName: "",
    mobileNumber: "",
    address: "",
    customerId: "",
    quarter: "",
    distributorLocation: "",
  });

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitSuccess, setSubmitSuccess] = useState(false);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const [showTerms, setShowTerms] = useState(false);
  const token = Cookies.get("token");
  const navigate = useNavigate();

  useEffect(() => {
    if (token) {
      try {
        const decoded = jwtDecode(token);
        if (decoded.customerId) {
          setFormData((prev) => ({
            ...prev,
            customerId: decoded.customerId,
          }));

          // Check if user has already submitted an agreement
          checkExistingAgreement(decoded.customerId);
        }
      } catch (error) {
        console.error("Error decoding token:", error);
      }
    }
  }, [token]);

  const checkExistingAgreement = async (customerId) => {
    try {
      setLoading(true);
      const response = await axios.get(
        `${API_BASE_URL}/useragreement/fetch-agreement?customerId=${customerId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response.data.data && response.data.data.length > 0) {
        setHasSubmitted(true);
      }
    } catch (err) {
      console.error("Error checking existing agreement:", err);
    } finally {
      setLoading(false);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    console.log("Form Data:", formData); // Log the form data
    setIsSubmitting(true);
    setError(null);

    try {
      const response = await axios.post(
        `${API_BASE_URL}/agreement-form/agreements`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      console.log("Agreement submitted:", response.data);
      setSubmitSuccess(true);
      setHasSubmitted(true);
    } catch (err) {
      console.error("Error submitting agreement:", err);
      setError(err?.response?.data?.message || "Failed to submit agreement");
    } finally {
      setIsSubmitting(false);
    }
  };

  if (loading) {
    return (
      <div className="flex items-center justify-center h-64">
        <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-blue-500"></div>
      </div>
    );
  }

  if (hasSubmitted) {
    return (
      <div 
      className="p-8 bg-white rounded-2xl max-w-3xl mt-16 mx-auto text-center border border-gray-100"
      style={{ 
        boxShadow: "0px 4px 20px rgba(28, 80, 163, 0.15)",
        background: "linear-gradient(to bottom, #FFFFFF 0%, #F8FAFF 100%)"
      }}
    >
      <div className="mb-6 flex justify-center">
        <div className="w-16 h-16 bg-[#E8F1FF] rounded-full flex items-center justify-center">
          <svg 
            width="32" 
            height="32" 
            viewBox="0 0 24 24" 
            fill="none" 
            xmlns="http://www.w3.org/2000/svg"
          >
            <path 
              d="M19 3H5C3.89543 3 3 3.89543 3 5V19C3 20.1046 3.89543 21 5 21H19C20.1046 21 21 20.1046 21 19V5C21 3.89543 20.1046 3 19 3Z" 
              stroke="#1C50A3" 
              strokeWidth="2" 
              strokeLinecap="round" 
              strokeLinejoin="round"
            />
            <path 
              d="M8 12H16" 
              stroke="#1C50A3" 
              strokeWidth="2" 
              strokeLinecap="round" 
              strokeLinejoin="round"
            />
            <path 
              d="M12 16V8" 
              stroke="#1C50A3" 
              strokeWidth="2" 
              strokeLinecap="round" 
              strokeLinejoin="round"
            />
          </svg>
        </div>
      </div>
    
      <h2 className="text-3xl font-bold text-gray-900 mb-3">
        Micro Distributor Agreement
      </h2>
      
      <p className="text-lg text-gray-600 mb-8 max-w-md mx-auto">
        Your agreement form has been successfully submitted and is now being processed.
      </p>
      
      <button
        onClick={() => navigate('/customer_dashboard/customer-agreement-details')}
        className="px-8 py-3 bg-[#1C50A3] text-white rounded-lg shadow-md hover:bg-[#16438A] transition-all duration-300 transform hover:-translate-y-1 focus:outline-none focus:ring-2 focus:ring-[#1C50A3] focus:ring-opacity-50"
      >
        <div className="flex items-center justify-center space-x-2">
          <svg 
            width="18" 
            height="18" 
            viewBox="0 0 24 24" 
            fill="none" 
            xmlns="http://www.w3.org/2000/svg"
          >
            <path 
              d="M1 12C1 12 5 4 12 4C19 4 23 12 23 12C23 12 19 20 12 20C5 20 1 12 1 12Z" 
              stroke="currentColor" 
              strokeWidth="2" 
              strokeLinecap="round" 
              strokeLinejoin="round"
            />
            <path 
              d="M12 15C13.6569 15 15 13.6569 15 12C15 10.3431 13.6569 9 12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15Z" 
              stroke="currentColor" 
              strokeWidth="2" 
              strokeLinecap="round" 
              strokeLinejoin="round"
            />
          </svg>
          <span>View Agreement Details</span>
        </div>
      </button>
    
     
    </div>
    );
  }
  return (
    <div
      className="p-6 bg-white rounded-xl max-w-4xl mt-20 mx-auto"
      style={{ boxShadow: "0px 10px 60px 0px #E2ECF980" }}
    >
      <div className="flex justify-between mb-2 items-center">
        <h2 className="text-2xl font-bold text-gray-800">
          Micro Distributor Agreement
        </h2>
       
      </div>

      {loading && (
        <div className="fixed inset-0 flex items-center justify-center bg-white bg-opacity-70 z-50">
          <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-blue-500"></div>
        </div>
      )}

      {submitSuccess && (
        <div className="mb-6 p-4 bg-green-50 rounded-md border border-green-200">
          <div className="flex items-center">
            <div className="flex-shrink-0">
              <svg
                className="h-5 w-5 text-green-400"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 20 20"
                fill="currentColor"
              >
                <path
                  fillRule="evenodd"
                  d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                  clipRule="evenodd"
                />
              </svg>
            </div>
            <div className="ml-3">
              <p className="text-sm font-medium text-green-800">
                Agreement submitted successfully! Thank you for your submission.
              </p>
            </div>
          </div>
        </div>
      )}

      {error && (
        <div className="mb-6 p-4 bg-red-50 rounded-md border border-red-200">
          <div className="flex items-center">
            <div className="flex-shrink-0">
              <svg
                className="h-5 w-5 text-red-400"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 20 20"
                fill="currentColor"
              >
                <path
                  fillRule="evenodd"
                  d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z"
                  clipRule="evenodd"
                />
              </svg>
            </div>
            <div className="ml-3">
              <p className="text-sm font-medium text-red-800">{error}</p>
            </div>
          </div>
        </div>
      )}

      <div className="mb-8">
        <p className="text-gray-600 mb-6">
          Dear Sir,
          <br />
          <br />
          This letter formally invites you to sign target acceptance against
          Category "Micro Distributor" Partner. To be eligible for Quarterly
          payout as an Authorized Micro Distributor.
        </p>
      </div>

      <form onSubmit={handleSubmit}>
        {/* Terms and Conditions Section */}
        <div className="mb-8 p-4 border border-gray-200 rounded-lg bg-gray-50">
          <div className="flex justify-between items-center mb-4">
            <h3 className="text-lg font-semibold text-gray-700">
              Terms and Conditions
            </h3>
            <button
              type="button"
              onClick={() => setShowTerms(!showTerms)}
              className="text-blue-600 text-sm font-medium"
            >
              {showTerms ? "Hide Terms" : "Show Terms"}
            </button>
          </div>

          {showTerms && (
            <div className="text-gray-600 text-sm space-y-3">
              <p>
                <strong>QUARTER VALID FOR:</strong> April to June (Q1) – AMJ
              </p>
              <p>
                <strong>TOD as per the following details:</strong>
              </p>
              <ul className="list-disc pl-5 mb-4">
                <li>
                  <strong>Buying Target 1.5 lac + GST:</strong> Payout 1%
                </li>
                <li>
                  <strong>Buying Target 2.5 Lac+ GST:</strong> Payout 1.5%
                </li>
                <li>
                  <strong>Buying Target 3.5 Lac+ GST:</strong> Payout 2.5%
                </li>
              </ul>

              <ol className="list-decimal pl-5 space-y-2">
                <li>
                  The Securenet incentive payout would be booked in the name of
                  the participating Micro Distributor partner only as per the
                  details mentioned in the target and acceptance letter.
                </li>
                <li>
                  This letter is strictly personalized for you and not
                  transferrable in any case.
                </li>
                <li>
                  You need to purchase Securenet products from specified
                  distributor only.
                </li>
                <li>
                  SPC (B2B AND SPECIAL PRICE BILLING) will not be considered for
                  target and TOD payout.
                </li>
                <li>
                  SSD, TONNER, RAM and Neo Series Products will not be counted
                  for TOD.
                </li>
                <li>
                  Min.30% monthly target must be achieved to be eligible for
                  quarterly payout and maintain Micro distributor status.
                </li>
                <li>
                  Your name will be published in our website as Auth. Micro
                  distributor.
                </li>
                <li>
                  Your invoices will be valid for company schemes being run from
                  company time to time for partners aligned with you.
                </li>
                <li>
                  Your aligned partners will be recognized by company as auth
                  partners, certificates will be given to them after
                  registration on company website.
                </li>
                <li>This program letter is valid for 1 quarter only.</li>
                <li>The company's decision is final regarding any dispute.</li>
              </ol>
            </div>
          )}
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <div>
            <label className="block text-gray-600 font-semibold mb-2">
              Location *
            </label>
            <input
              type="text"
              name="location"
              value={formData.location}
              onChange={handleChange}
              required
              className="w-full p-2 border border-gray-300 rounded-md shadow-sm outline-none focus:ring-1 focus:ring-gray-300 focus:border-gray-300 appearance-none"
            />
          </div>
          <div>
            <label className="block text-gray-600 font-semibold mb-2">
              Quarter *
            </label>
            <input
              type="text"
              name="quarter"
              value={formData.quarter}
              onChange={handleChange}
              required
              className="w-full p-2 border border-gray-300 rounded-md shadow-sm outline-none focus:ring-1 focus:ring-gray-300 focus:border-gray-300 appearance-none"
            />
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-4">
          <div>
            <label className="block text-gray-600 font-semibold mb-2">
              Bank Account Number *
            </label>
            <input
              type="text"
              name="bankAccountNumber"
              value={formData.bankAccountNumber}
              onChange={handleChange}
              required
              className="w-full p-2 border border-gray-300 rounded-md shadow-sm outline-none focus:ring-1 focus:ring-gray-300 focus:border-gray-300 appearance-none"
            />
          </div>
          <div>
            <label className="block text-gray-600 font-semibold mb-2">
              IFSC Code *
            </label>
            <input
              type="text"
              name="ifscCode"
              value={formData.ifscCode}
              onChange={handleChange}
              required
              className="w-full p-2 border border-gray-300 rounded-md shadow-sm outline-none focus:ring-1 focus:ring-gray-300 focus:border-gray-300 appearance-none uppercase"
            />
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-4">
          <div>
            <label className="block text-gray-600 font-semibold mb-2">
              Purchase From Distributor *
            </label>
            <select
              name="purchaseDistributor"
              value={formData.purchaseDistributor}
              onChange={handleChange}
              required
              className="w-full p-2 border border-gray-300 rounded-md shadow-sm outline-none focus:ring-1 focus:ring-gray-300 focus:border-gray-300 appearance-none"
            >
              <option value="">Select Your Dealer</option>
<option value="ALL_FORTECH">ALL FORTECH</option>
<option value="COMPUTER_PROFESSIONAL">COMPUTER PROFESSIONAL</option>
<option value="COMTECH_SOLUTION_POINT">COMTECH SOLUTION POINT</option>
<option value="CREATIVE_IT_HUB">CREATIVE IT HUB</option>
<option value="DIGITAL_EQUIPMENTS">DIGITAL EQUIPMENTS</option>
<option value="DOCKET_CARE_SYSTEMS">DOCKET CARE SYSTEMS</option>
<option value="FORTECH">FORTECH</option>
<option value="GROWTH_PARTNERS">GROWTH PARTNERS</option>
<option value="HITECH_SOLUTIONS">HITECH SOLUTIONS</option>
<option value="JALAN_DISTRIBUTORS">JALAN DISTRIBUTORS</option>
<option value="MICRO_INFOSOLUTIONS">MICRO INFOSOLUTIONS PRIVATE LIMITED</option>
<option value="PIONEER_COMPUTER">PIONEER COMPUTER</option>
<option value="PRANSH_DIGITAL_PRIVATE_LIMITED">PRANSH DIGITAL PRIVATE LIMITED</option>
<option value="SATYA_IT_SOLUTION">SATYA IT SOLUTION</option>
<option value="SRK_ENTERPRISES">SRK ENTERPRISES</option>
<option value="STEK SYSTEM">STEK SYSTEM</option>
<option value="UNIVERSAL">UNIVERSAL</option>
<option value="VISION_INDIA">VISION INDIA</option>

            </select>
          </div>
          <div>
            <label className="block text-gray-600 font-semibold mb-2">
              Authorized Distributor for Region *
            </label>
            <input
              type="text"
              name="authorizedDistributor"
              value={formData.authorizedDistributor}
              onChange={handleChange}
              required
              className="w-full p-2 border border-gray-300 rounded-md shadow-sm outline-none focus:ring-1 focus:ring-gray-300 focus:border-gray-300 appearance-none"
            />
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-4">
          <div>
            <label className="block text-gray-600 font-semibold mb-2">
              Partner Name/Firm Name *
            </label>
            <input
              type="text"
              name="partnerName"
              value={formData.partnerName}
              onChange={handleChange}
              required
              className="w-full p-2 border border-gray-300 rounded-md shadow-sm outline-none focus:ring-1 focus:ring-gray-300 focus:border-gray-300 appearance-none"
            />
          </div>
          <div>
            <label className="block text-gray-600 font-semibold mb-2">
              Contact Person Name *
            </label>
            <input
              type="text"
              name="contactPersonName"
              value={formData.contactPersonName}
              onChange={handleChange}
              required
              className="w-full p-2 border border-gray-300 rounded-md shadow-sm outline-none focus:ring-1 focus:ring-gray-300 focus:border-gray-300 appearance-none"
            />
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-4">
          <div>
            <label className="block text-gray-600 font-semibold mb-2">
              Distributor Location *
            </label>
            <select
              name="distributorLocation"
              value={formData.distributorLocation}
              onChange={handleChange}
              required
              className="w-full p-2 border border-gray-300 rounded-md shadow-sm outline-none focus:ring-1 focus:ring-gray-300 focus:border-gray-300 appearance-none"
            >
              <option value="">Select Location</option>
              <option value="NEW DELHI">NEW DELHI</option>
              <option value="PRAYAGRAJ">PRAYAGRAJ</option>
              <option value="GORAKHPUR">GORAKHPUR</option>
              <option value="KANPUR">KANPUR</option>
              <option value="RAIPUR">RAIPUR</option>
              <option value="INDORE">INDORE</option>
              <option value="AHMEDABAD">AHMEDABAD</option>
              <option value="VARANASI">VARANASI</option>
              <option value="LUCKNOW">LUCKNOW</option>
              <option value="PATNA">PATNA</option>
              <option value="MEERUT">MEERUT</option>
              <option value="DEHRADUN">DEHRADUN</option>
              <option value="ODISHA">ODISHA</option>
            </select>
          </div>
        </div>

        <div className="mt-4">
          <label className="block text-gray-600 font-semibold mb-2">
            Mobile Number *
          </label>
          <input
            type="tel"
            name="mobileNumber"
            value={formData.mobileNumber}
            onChange={handleChange}
            required
            className="w-full p-2 border border-gray-300 rounded-md shadow-sm outline-none focus:ring-1 focus:ring-gray-300 focus:border-gray-300 appearance-none"
          />
        </div>

        <div className="mt-4">
          <label className="block text-gray-600 font-semibold mb-2">
            Address *
          </label>
          <textarea
            name="address"
            rows={4}
            value={formData.address}
            onChange={handleChange}
            required
            className="w-full p-2 border border-gray-300 rounded-md shadow-sm outline-none focus:ring-1 focus:ring-gray-300 focus:border-gray-300 appearance-none"
          />
        </div>

        <div className="mt-8">
          <div className="flex items-center mb-4">
            <input
              id="agree-terms"
              type="checkbox"
              required
              className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500"
            />
            <label
              htmlFor="agree-terms"
              className="ml-2 text-sm font-medium text-gray-700"
            >
              I agree to all the Terms and Conditions mentioned above
            </label>
          </div>
        </div>

        <div className="flex justify-end mt-6">
          <button
            type="submit"
            disabled={isSubmitting}
            className={`bg-[#1C50A3] w-full text-white py-3 px-4 rounded-lg shadow-lg transition duration-300 ${isSubmitting
              ? "opacity-50 cursor-not-allowed"
              : "hover:bg-blue-700"
              }`}
          >
            {isSubmitting ? "Submitting..." : "Submit Agreement"}
          </button>
        </div>
      </form>
    </div>
  );
};

export default AgreementForm;
